import { chain } from 'lodash-es'

export default class MatchingUsers {
    #element

    #registered
    #tags

    #modeElement
    #tagsElement

    constructor(element) {
        this.#element = element

        this.#registered = parseInt(element.dataset.registered)
        this.#tags = JSON.parse(element.dataset.tags)

        this.#modeElement = document.getElementById(element.dataset.modeElement)
        this.#tagsElement = document.getElementById(element.dataset.tagsElement)

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new MatchingUsers(element))
    }

    #bindEvents() {
        this.#recalculate()

        this.#modeElement.addEventListener('change', this.#recalculate)
        this.#tagsElement.addEventListener('change', this.#recalculate)
    }

    #recalculate = () => {
        if (this.#modeElement.value === 'all') {
            return this.#setValue(this.#registered)
        }

        if (this.#modeElement.value === 'anonymous') {
            return this.#setValue(0)
        }

        let selectedTags = Array.from(this.#tagsElement.options)
            .filter((opt) => opt.selected)
            .map((opt) => opt.value)

        if (selectedTags.length === 0) {
            return this.#setValue(this.#registered)
        }

        let users = chain(this.#tags).pick(selectedTags).values().flatten().uniq()

        return this.#setValue(users.size())
    }

    #setValue = (value) => {
        this.#element.value = value
        this.#element.dispatchEvent(new Event('change'))
    }
}
